import { Button, TextField } from '@mui/material';
import { L } from 'harmony-language';
import React, { FormEvent } from 'react';
import type { LocationGroup } from '../../../types';
import { ColorSelector } from '../../shared/inputs/color-selector';
import { EntityColors } from '../../../styles/agistics-colors';

interface EditCreateLocationGroupProps {
    existingLocationGroup: LocationGroup;
    addLocationGroup: (data: LocationGroup) => Promise<void>;
    editLocationGroup: (data: LocationGroup) => Promise<void>;
    closeModal: () => void;
}

export const EditCreateLocationGroup = (props: EditCreateLocationGroupProps) => {
    const { existingLocationGroup, addLocationGroup, editLocationGroup, closeModal } = props;

    const [locationGroup, setLocationGroup] = React.useState<LocationGroup>(existingLocationGroup || {
        name: '',
        hexColor: '',
    });

    async function submitForm(e: FormEvent<HTMLFormElement>) {
        e.preventDefault();
        e.stopPropagation();

        if (locationGroup.id) {
            await editLocationGroup(locationGroup);
        } else {
            await addLocationGroup(locationGroup);
        }

        closeModal();
    }

    return (
        <div style={{ minWidth: '20vw' }}>
            <form id='edit-create-location-group-form' name='edit-create-location-group-form' onSubmit={submitForm}>
                <div style ={{ display: 'flex', flexDirection: 'row', gap: '1rem', alignItems: 'flex-end' }}>
                    <TextField
                        label={L.name()}
                        variant='standard'
                        value={locationGroup.name}
                        onChange={(e) => setLocationGroup(locationGroup => ({ ...locationGroup, name: e.target.value }))}
                        fullWidth
                        required
                    />
                    <ColorSelector
                        value={locationGroup.hexColor}
                        onChange={(color) => setLocationGroup(locationGroup => ({ ...locationGroup, hexColor: color }))}
                        colors={Object.values(EntityColors)}
                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1rem' }}>
                    <Button
                        type='submit'
                        title={L.save()}
                        variant='contained'
                        color='primary'
                    >
                        {existingLocationGroup ? L.updateLocationGroup() : L.createLocationGroup()}
                    </Button>
                </div>
            </form>
        </div>
    );
};